import React, {
    useEffect,
    useState,
    useCallback
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useAuthentication } from 'gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { messages } from 'gw-capability-policychange-common-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import styles from './QuotePage.module.scss';
import metadata from './QuotePage.metadata.json5';


function QuotePage(props) {
    const { wizardData, updateWizardData } = props;
    const { submissionVM } = wizardData;
    const { isLoggedIn } = useAuthentication();
    const [allDrivers, setAllDrivers] = useState();
    const [allVehicles, setAllVehicles] = useState();

    useEffect(() => {
        const setDriverNames = () => {
            const drivers = _.get(
                submissionVM.value,
                'lobData.personalAuto.coverables.drivers',
                []
            );
            const driverNames = drivers.map((driver) => driver.displayName);
            setAllDrivers(driverNames.join());
        };

        const setVehicleNames = () => {
            const vehicles = _.get(
                submissionVM.value,
                'lobData.personalAuto.coverables.vehicles',
                []
            );
            const vehicleNames = vehicles.map((vehicle) => vehicle.displayName);
            setAllVehicles(vehicleNames.join());
        };

        if (isLoggedIn) {
            setDriverNames();
            setVehicleNames();
        }
    }, [isLoggedIn, submissionVM, updateWizardData]);

    const resolvers = {
        resolveClassNameMap: styles
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        drivers: {
            value: allDrivers
        },
        vehicles: {
            value: allVehicles
        },
        dateId: {
            labelPosition: undefined
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [overrideProps, submissionVM]
    );

    return (
        <WizardPage
            cancelLabel={(appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                resolveValue={readValue}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

QuotePage.propTypes = wizardProps;
export default QuotePage;
